import { Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ExperienceType } from '@/generated/graphql'

import { BackgroundInputType, UserInfoBackgroundInner } from '../user-info-background/user-info-background.component'
import { UserInfoProps } from '../user-info.interface'

export const UserInfoEditModalBackground: React.FC<UserInfoProps> = ({ userId, readonly }) => {
  const { t } = useTranslation()
  const [educationInput, setEducationInput] = React.useState<BackgroundInputType>({ type: ExperienceType.Education })
  const [careerInput, setCareerInput] = React.useState<BackgroundInputType>({ type: ExperienceType.Career })

  return (
    <div>
      <Typography.Title level={5}>{t('user.info.background.title')}</Typography.Title>
      <UserInfoBackgroundInner
        key={ExperienceType.Career}
        backgroundType={ExperienceType.Career}
        input={careerInput}
        setInput={setCareerInput}
        userId={userId}
        readonly={readonly}
        hiddenTitle={true}
        bodyStyle={{ padding: '0 15px' }}
      />
      <UserInfoBackgroundInner
        key={ExperienceType.Education}
        backgroundType={ExperienceType.Education}
        input={educationInput}
        setInput={setEducationInput}
        userId={userId}
        readonly={readonly}
        hiddenTitle={true}
        bodyStyle={{ padding: '0 15px' }}
      />
    </div>
  )
}
